import { FaultTypeOption } from 'pages/Desk/issues/fault_type/FaultTypesInput';
import { Lozenge } from 'shared/lozenge/Lozenge';
import { tokens } from 'styles/tokens';

export type FaultTypeLozengeProps = Readonly<{
    faultType: FaultTypeOption;
    onRemove?: () => void;
}>;

export function FaultTypeLozenge({ faultType, onRemove }: FaultTypeLozengeProps) {
    return (
        <Lozenge
            backgroundColor={tokens.grey.default}
            color={tokens.text.primaryInverse}
            onRemove={onRemove}
        >
            {faultType.FullName}
        </Lozenge>
    );
}
